export default function resolveFinalNotation(forceCompactNotationAbove, value, userNotation) {
    if (typeof forceCompactNotationAbove !== 'undefined' && Math.abs(value) > Math.abs(forceCompactNotationAbove)) {
        return 'compact';
    }
    return userNotation;
}

//# sourceMappingURL=resolveFinalNotation.js.map